// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2-o79","imageUploader":"EGiftCard_imageUploader__2VJmv"};